module.exports = __webpack_public_path__ + "static/media/Group 140.6d75c808.png";